module.exports = __webpack_public_path__ + "static/media/status-cry.89d65816.png";